import { render } from "./QCTask.vue?vue&type=template&id=3236f388&scoped=true"
import script from "./QCTask.vue?vue&type=script&lang=js"
export * from "./QCTask.vue?vue&type=script&lang=js"

import "./QCTask.vue?vue&type=style&index=0&id=3236f388&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3236f388"]])

export default __exports__